import { X } from 'lucide-react';

export default function RecentSearches({ searches, onSearch, onClear }) {
    if (!searches.length) return null;

    return (
        <div>
            <div className="mb-3 flex items-center justify-between">
                <h3 className="text-xs font-semibold tracking-[0.25em] text-muted-foreground uppercase">
                    Recent Searches
                </h3>

                <button
                    type="button"
                    onClick={onClear}
                    className="text-xs text-muted-foreground transition hover:text-foreground"
                >
                    Clear all
                </button>
            </div>

            <div className="flex flex-wrap gap-2">
                {searches.map((search) => (
                    <button
                        key={search}
                        type="button"
                        onClick={() => onSearch(search)}
                        className="inline-flex items-center gap-2 rounded-full bg-slate-300 px-3 py-1.5 text-sm transition hover:bg-slate-200/90 focus:ring-2 focus:ring-ring focus:outline-none"
                    >
                        {search}
                        <X
                            className="size-3 text-muted-foreground"
                            aria-hidden="true"
                        />
                    </button>
                ))}
            </div>
        </div>
    );
}
